import BigNumber from 'bignumber.js'

// 加
const _Aso_Plus = (a, b, dp = 0) => {
  return new BigNumber(a).plus(b).dp(dp).toNumber()
}

// 减
const _Aso_Minus = (a, b, dp = 0) => {
  return new BigNumber(a).minus(b).dp(dp).toNumber()
}

// 乘
const _Aso_Times = (a, b, dp = 0) => {
  return new BigNumber(a).times(b).dp(dp).toNumber()
}

// 除
const _Aso_Divide = (a, b, dp = 0) => {
  return new BigNumber(a).div(b).dp(dp).toNumber()
}

export {
  _Aso_Plus,
  _Aso_Minus,
  _Aso_Times,
  _Aso_Divide
}
